<template>
    <span class="ath-visual-text">
        <span class="el-stencil el--t-txt" style="width: 8rem;"></span>
    </span>
</template>

<script>
export default {
    name: 'mead-text-stencil',
};
</script>
